import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { makeArticle } from './styled'
import ForwardIcon from '../forwardIcon'
import ClickableContent from '../clickable-content'

export const RawArticle = makeArticle('div')

const StyledHeader = styled.h3`
  margin-top: 0;
`

function Article(props) {
  return (
    <RawArticle {...props}>
      <ClickableContent href={props.path} target='_blank'>
        <img className='articleImage' src={props.imagePath} />
        <div className='articleInfo'>
          <StyledHeader>{props.header}</StyledHeader>
          <p>{props.subheader}</p>
          <div className='readMore'>
            <span>Read More</span>
            <ForwardIcon />
          </div>
        </div>
      </ClickableContent>
    </RawArticle>
  )
}

Article.propTypes = {
  imagePath: PropTypes.string,
  header: PropTypes.string,
  subheader: PropTypes.string,
}

export default Article
